import Layout from "@/components/feature/Layout";
import useScrollReveal from "@/hooks/useScrollReveal";
import { clinicInfo, faqs } from "@/mocks/site";
import { doctors } from "@/data/doctors";
import Hero from "./sections/Hero";
import Intro from "./sections/Intro";
import CareAreas from "./sections/CareAreas";
import { OrthoFeature, SpineFeature } from "./sections/CareFeatures";
import DoctorSpotlight from "./sections/DoctorSpotlight";
import GalleryPreview from "./sections/GalleryPreview";
import BlogSection from "./sections/BlogSection";
import FaqSection from "./sections/FaqSection";
import { AppointmentCta, Contact } from "./sections/AppointmentCta";

const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "MedicalClinic",
      "@id": "https://orthospine.care/#clinic",
      name: "Ortho Spine Care",
      description:
        "Orthopaedic and spine surgery practice in Srirangam, Trichy, led by Dr. N. Ajit Kumar, Senior Consultant in Orthopaedic and Spine Surgery.",
      url: "https://orthospine.care/",
      telephone: clinicInfo.phoneDisplay,
      image: clinicInfo.logo,
      medicalSpecialty: ["Orthopedic", "Spine Surgery"],
      address: {
        "@type": "PostalAddress",
        streetAddress: clinicInfo.addressLine1,
        addressLocality: clinicInfo.city,
        addressRegion: clinicInfo.region,
        postalCode: "620005",
        addressCountry: "IN",
      },
      employee: [
        {
          "@type": "Physician",
          "@id": "https://orthospine.care/#physician",
          name: doctors[0].name,
          jobTitle: doctors[0].designation,
          image: doctors[0].image,
          medicalSpecialty: ["Orthopedic", "Spine Surgery"],
          url: "https://orthospine.care/about#specialist",
        },
      ],
    },
    {
      "@type": "WebSite",
      "@id": "https://orthospine.care/#website",
      name: "Ortho Spine Care",
      url: "https://orthospine.care/",
    },
    {
      "@type": "FAQPage",
      "@id": "https://orthospine.care/#faq",
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.q,
        acceptedAnswer: { "@type": "Answer", text: faq.a },
      })),
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://orthospine.care/#breadcrumb",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://orthospine.care/" },
      ],
    },
  ],
};

export default function Home() {
  useScrollReveal();

  return (
    <Layout>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <Hero />
      <Intro />
      <CareAreas />
      <OrthoFeature />
      <SpineFeature />
      <DoctorSpotlight />
      <GalleryPreview />
      <BlogSection />
      <FaqSection />
      <AppointmentCta />
      <Contact />
    </Layout>
  );
}